module.exports = __webpack_public_path__ + "static/img/logo-Governo-2025.f61ad08c.svg";